module.exports = __webpack_public_path__ + "ptc_nakagawa_R2.96987fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_R2.jpg
// module id = FZbV
// module chunks = 0